// import { useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { deleteSubscriptionApi } from "../../apis/subscriptionApi";

// export const useDeleteSubscription = () => {
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const deleteSubscription = useCallback(async (id) => {
//     setLoading(true);
//     setError(null);

//     const toastId = toast.loading("Deleting subscription...");

//     try {
//       await deleteSubscriptionApi(id);

//       toast.update(toastId, {
//         render: "Subscription deleted",
//         type: "success",
//         isLoading: false,
//         autoClose: 2000,
//       });

//       return true;
//     } catch (err) {
//       const msg = err.message || "Delete failed";
//       setError(msg);

//       toast.update(toastId, {
//         render: msg,
//         type: "error",
//         isLoading: false,
//         autoClose: 4000,
//       });

//       throw err;
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   return { deleteSubscription, loading, error };
// };

import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import { deleteSubscriptionApi } from "../../apis/subscriptionApi";

export const useDeleteSubscription = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
    // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
        "Failed to delete subscription.",
    };
  };

  const deleteSubscription = useCallback(async (id) => {
    setLoading(true);
    setError(null);

    const toastId = toast.loading("Deleting subscription...");

    try {
      await deleteSubscriptionApi(id);

      toast.update(toastId, {
        render: (
          <div>
            <strong>Subscription Deleted</strong>
            <div>Subscription deleted successfully.</div>
          </div>
        ),
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });

      return true;
    } catch (err) {
      const { title, issue } = extractError(err);

      toast.update(toastId, {
        render: (
          <div>
            <strong>{title}</strong>
            <div>{issue}</div>
          </div>
        ),
        type: "error",
        isLoading: false,
        autoClose: 4000,
      });

      setError({ title, issue });
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { deleteSubscription, loading, error };
};